import "./Company.module.css";
import Header from "@/reusable_sections/Header";
import OurPhilosophy from "./sections/OurPhilosophy";
import TheTeamOfExperts from "./sections/TheTeamOfExperts";
import Footer from "@/reusable_sections/Footer";
export default function CompanyPage() {
  return <div>
      <Header />
      <OurPhilosophy />
      <TheTeamOfExperts />
      <Footer />
    </div>;
}